import { getDefaultStore } from 'jotai'

import {
  selectedDateAtom,
  selectedOfferAtom,
  selectedPassengersAtom,
  selectedRoutesAtom,
  selectedVehiclesAtom,
} from '@/states/selectionAtom'

import { getSessionCommercialDiscount } from '@/utils/sessionStorage'

export const constructYourBookingUrl = (bypassOfferCode = false): string => {
  const store = getDefaultStore()
  const selectedRoutes = store.get(selectedRoutesAtom)
  const selectedVehicles = store.get(selectedVehiclesAtom)
  const selectedDate = store.get(selectedDateAtom)
  const selectedPassengers = store.get(selectedPassengersAtom)
  const offerCode = store.get(selectedOfferAtom)

  const urlParams = new URLSearchParams()
  if (!selectedRoutes?.outbound || !selectedDate?.outboundDepartureDate || !selectedVehicles?.vehicleCode || !selectedPassengers?.adults)
    return location.pathname.split('/').slice(0, -1).join('/')
  urlParams.append('routeOut', selectedRoutes.outbound)
  urlParams.append('depDateOut', selectedDate.outboundDepartureDate)
  urlParams.append('routeHome', !selectedRoutes?.homebound ? 'ONE_WAY' : selectedRoutes.homebound)
  if (selectedDate?.returnDepartureDate) urlParams.append('depDateHome', selectedDate.returnDepartureDate)
  urlParams.append('vty', selectedVehicles.vehicleCode)
  if (selectedVehicles?.trailerCode) urlParams.append('tty', selectedVehicles.trailerCode)
  urlParams.append('adl', selectedPassengers.adults.toString())
  selectedPassengers.childrenAges.map((age: number) => urlParams.append('chdAges', age.toString()))
  if (!bypassOfferCode && offerCode && offerCode.offerCode) {
    urlParams.append('offer', offerCode.offerCode)
  }
  const commercialDiscount = getSessionCommercialDiscount()
  if (commercialDiscount) urlParams.append('commercialDiscount', commercialDiscount)
  const url = sessionStorage['yourBookingUrl'] && JSON.parse(sessionStorage['yourBookingUrl'])
  return `${url}?${urlParams.toString()}`
}
